import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('trax-cookie-consent');
    if (!consent) {
      setTimeout(() => setIsVisible(true), 1500);
    }
  }, []);

  const handleAccept = () => {
    setIsAnimating(true);
    setTimeout(() => {
      localStorage.setItem('trax-cookie-consent', 'accepted');
      setIsVisible(false);
    }, 300);
  };

  const handleReject = () => {
    setIsAnimating(true);
    setTimeout(() => {
      localStorage.setItem('trax-cookie-consent', 'rejected');
      setIsVisible(false);
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6 transition-all duration-500 ${
        isAnimating ? 'translate-y-full opacity-0' : 'translate-y-0 opacity-100'
      }`}
    >
      <div className="max-w-4xl mx-auto bg-[#0A0A0A] border border-[#E31E24]/30 rounded-2xl p-5 sm:p-6 shadow-2xl shadow-black/30">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <span className="text-xl">🍪</span>
              <h3 className="text-white font-bold text-sm">Çerez Kullanımı</h3>
            </div>
            <p className="text-gray-400 text-xs leading-relaxed">
              Bu web sitesi, deneyiminizi geliştirmek için çerezler kullanır. 
              Sepet bilgilerinizi saklamak, dil tercihlerinizi hatırlamak ve 
              site kullanımını analiz etmek amacıyla çerezler kullanıyoruz. 
              Daha fazla bilgi için{' '}
              <Link to="/gizlilik-politikasi" className="text-[#E31E24] hover:underline">
                Gizlilik Politikamızı
              </Link>{' '}
              inceleyebilirsiniz.
            </p>
          </div>
          <div className="flex gap-2 shrink-0 w-full sm:w-auto">
            <button
              onClick={handleAccept}
              className="flex-1 sm:flex-none px-5 py-2.5 bg-gradient-to-r from-[#E31E24] to-[#FF4500] text-white font-bold text-xs rounded-xl hover:shadow-lg transition-all duration-300"
            >
              Kabul Et
            </button>
            <button
              onClick={handleReject}
              className="flex-1 sm:flex-none px-5 py-2.5 bg-gray-800 text-gray-300 font-semibold text-xs rounded-xl hover:bg-gray-700 transition-all duration-300"
            >
              Reddet
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
